import type { DetailedCaseInfo } from '$types/cases.type';
import type { CaseStore, MainRoute } from '$types/cases.type';
import { definedNotNull } from '@df/common';
import { writable } from 'svelte/store';

function createCaseStore() {
  const store = writable<CaseStore | undefined>();

  function getLatestAuditRoute(key: MainRoute, data: CaseStore | undefined) {
    return data?.routes[key];
  }

  function getRouteKey(url: URL) {
    return url.pathname.split('/')[4] as MainRoute;
  }

  function updateLatestRoutes(url: URL) {
    const routeKey = getRouteKey(url);

    update((cStore) => {
      if (definedNotNull(cStore)) {
        cStore.routes[routeKey] = url.href;
      }
      return cStore;
    });
  }

  // Reads only `custom.hasLedger`, available on the plain DetailedCaseInfo — so callers
  // with case info from context (no routes) can use this without going through the store.
  function hasLedger(data: DetailedCaseInfo | undefined): boolean {
    return (
      data?.custom.hasLedger === 'DiffinderLedgerAvailable' ||
      data?.custom.hasLedger === 'ExternalLedgerAvailable'
    );
  }

  const { subscribe, set, update } = store;

  return {
    subscribe,
    set,
    update,
    getLatestAuditRoute,
    getRouteKey,
    updateLatestRoutes,
    hasLedger,
  };
}

export const caseStore = createCaseStore();
